import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { alphaVantageService } from '@/services/alphaVantage/alphaVantageService';

// Initialize Alpha Vantage API key for fundamental and overview data
// Check for browser vs Node.js environment
const apiKey = (typeof process !== 'undefined' && process.env) 
  ? process.env.VITE_ALPHA_VANTAGE_API_KEY || ''
  : (import.meta as any).env?.VITE_ALPHA_VANTAGE_API_KEY || '';

alphaVantageService.setApiKey(apiKey);

// Create root and render app
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
